/**
 * Partners Slider
 *
 * @since 1.0.0
 * @package geo_med
 */

(function($) {

	$(document).ready(function(){

		if ( $('.carousel-partners').length ) {
			$('.carousel-partners').flickity({
				// options
				cellAlign: 	'center',
				contain: true,
				lazyLoad: false,
				imagesLoaded: true,
				percentPosition: false,
				wrapAround: false,
				pageDots: false
			});
		}

	});

})(jQuery);